// extracted by mini-css-extract-plugin
export var box = "_7q-1";
export var checkboxRow = "_7q-8";
export var checked = "_7q-2";
export var descriptionSpacer = "_7q-a";
export var disabled = "_7q-3";
export var icon = "_7q-6";
export var input = "_7q-0";
export var labelSpacer = "_7q-9";
export var medium = "_7q-5";
export var small = "_7q-4";
export var text = "_7q-7";